export default __webpack_public_path__ + "static/videocover-afc86f5272cfd60ac1a9889e879b04b6.webp";